import { render, staticRenderFns } from "./cHuanJing.vue?vue&type=template&id=72c9d6ed&scoped=true&"
import script from "./cHuanJing.vue?vue&type=script&lang=js&"
export * from "./cHuanJing.vue?vue&type=script&lang=js&"
import style0 from "./cHuanJing.vue?vue&type=style&index=0&id=72c9d6ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c9d6ed",
  null
  
)

export default component.exports